import { BellAlertIcon, BellIcon } from "@heroicons/react/24/solid";
import React, { useEffect, useState } from "react";
import { getMentionsFromEmployee } from "../services/mentions/getMentionsFromEmployee";
import { uptadeIsNewMention } from "../services/mentions/updateIsNewMention";

function NotificationBell() {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [notifications, setNotifications] = useState([]);

    useEffect(() => {
        const fetchNotifications = async () => {
            const response = await getMentionsFromEmployee();
            console.log("notifications", response);
            if (response.data.success) {
                setNotifications(response.data.mentions);
            }
        };

        fetchNotifications();
    }, []);

    const updateMentionStatus = async (notificationId) => {
        const response = await uptadeIsNewMention(notificationId);
        console.log("notificationId", response);

        if (response.data.success) {
            setNotifications(
                notifications.map((n) =>
                    n.id === notificationId ? { ...n, isNew: false } : n
                )
            );
        }
    };

    const clickOnNotification = (notification) => {
        if (notification.isNew) {
            updateMentionStatus(notification.id);
        }
        if (
            notification.mentionType === "Subscription" ||
            notification.mentionType === "Job"
        ) {
            window.location.href = `/clients/service/${notification.clientServiceSubscriptionId}/client/${notification.clientId}`;
        }
    };

    return (
        <div className="relative ml-auto">
            <button
                className="relative flex items-center justify-center w-8 h-8 transition duration-150 rounded-full bg-slate-100 hover:bg-slate-200"
                onClick={() => setDropdownOpen(!dropdownOpen)}
            >
                <span className="sr-only">View notifications</span>
                {notifications.filter((n) => n.isNew).length === 0 && (
                    <BellIcon className="w-5 h-5 text-slate-500" />
                )}
                {notifications.filter((n) => n.isNew).length > 0 && (
                    <>
                        <BellAlertIcon className="w-5 h-5 text-slate-500" />
                        <span className="absolute top-0 right-0 inline-block w-2 h-2 bg-red-600 rounded-full"></span>
                    </>
                )}
            </button>
            {dropdownOpen && (
                <div className="absolute right-0 z-50 w-96 max-w-[90vw] mt-2 bg-white border rounded-lg shadow-lg border-slate-200">
                    <div className="p-2 max-h-96 overflow-y-auto">
                        {notifications.length === 0 ? (
                            <div className="px-3 py-4 text-sm text-slate-500">
                                No notifications
                            </div>
                        ) : (
                            notifications.map((notification) => (
                                <button
                                    key={notification.id}
                                    type="button"
                                    onClick={() =>
                                        clickOnNotification(notification)
                                    }
                                    className="flex w-full items-start justify-between gap-3 rounded-md px-3 py-3 text-left transition hover:bg-slate-100"
                                >
                                    <div
                                        className="text-sm font-semibold leading-6 text-slate-700"
                                    >
                                        {notification.message}
                                    </div>
                                    <div className="shrink-0 pt-0.5">
                                        {notification.isNew && (
                                            <small className="font-semibold text-teal-500">
                                                New!
                                            </small>
                                        )}
                                    </div>
                                </button>
                            ))
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

export default NotificationBell;
